import { render } from "./CommodityRecord.vue?vue&type=template&id=3e98cf6c&scoped=true&ts=true"
import script from "./CommodityRecord.vue?vue&type=script&lang=ts"
export * from "./CommodityRecord.vue?vue&type=script&lang=ts"

import "./CommodityRecord.vue?vue&type=style&index=0&id=3e98cf6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e98cf6c"]])

export default __exports__